import React, { useState } from 'react';
import { FiCalendar, FiCheck } from 'react-icons/fi';
import { FaMoneyCheckAlt } from "react-icons/fa";

const ManualDepositModal = ({ 
  show, 
  onClose, 
  income, 
  onConfirm, 
  loading = false 
}) => {
  const [actualAmount, setActualAmount] = useState(income?.amount || 0);
  const [depositDate, setDepositDate] = useState(
    new Date().toISOString().split('T')[0]
  );

  const handleConfirm = () => {
    onConfirm({
      incomeId: income._id,
      actualAmount: Number(actualAmount),
      depositDate: new Date(depositDate),
      accountId: income.account
    });
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-md w-full shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
              <FaMoneyCheckAlt className="w-5 h-5 text-btn-secondary" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Manual Deposit</h2>
              <p className="text-sm text-gray-600">{income?.name}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Actual Amount */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Actual Amount
            </label>
            <div className="relative">
              <FaMoneyCheckAlt className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
              <input
                type="number"
                value={actualAmount}
                onChange={(e) => setActualAmount(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Expected: {income?.currency} {Number(income?.amount || 0).toFixed(2)}
            </p>
          </div>

          {/* Deposit Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Deposit Date
            </label>
            <div className="relative">
              <FiCalendar className="absolute left-3 top-3 w-4 h-4 text-gray-400" />
              <input
                type="date"
                value={depositDate}
                onChange={(e) => setDepositDate(e.target.value)}
                max={new Date().toISOString().split('T')[0]}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Account Info */}
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-sm text-gray-600">
              Depositing to: <span className="font-medium text-gray-900">{income?.accountName || 'Selected Account'}</span>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading || !actualAmount}
            className="flex items-center gap-2 px-4 py-2 bg-btn-primary text-white rounded-lg hover:bg-btn-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <FiCheck className="w-4 h-4" />
            )}
            Confirm Deposit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManualDepositModal;